import React, { useMemo } from 'react';
import { BrowserDOMPurify } from '../utils/dompurify';

interface SanitizedHtmlProps {
  content: string;
  className?: string;
}

export const SanitizedHtml = React.memo<SanitizedHtmlProps>(({ content, className }) => {
  const sanitizedContent = useMemo(() => BrowserDOMPurify.sanitize(content || ''), [content]);

  // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitization is handled by DOMPurify
  return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />;
});

SanitizedHtml.displayName = 'SanitizedHtml';
